import React, { useEffect, useState } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import { Accordion, Form } from 'react-bootstrap';
import 'react-multi-carousel/lib/styles.css';

//component
import Banner from '../banner/banner'
import Requests from './requests'
import Introduction from './introduction'



function Products() {
 

  return (
    <>
    <div className='container bg-white p-3 m-3'>
      <div className='title pb-2'>
        <h6>صفحه محصولات</h6>
      </div>
      <div className=''>
      <Accordion  >
          <div className=' [&>div]:px-2 [&>div]:py-3'>
            <div className='12'>
              <Accordion.Item eventKey="0">
                <Accordion.Header>تصاویر بنر صفحه استخدام</Accordion.Header>
                <Accordion.Body>
                <Banner slug="employment1"/>
                </Accordion.Body>
              </Accordion.Item>
            </div>
            <div>
              <Accordion.Item eventKey="1">
                <Accordion.Header>لیست درخواست های ثبت شده</Accordion.Header>
                <Accordion.Body>
                    <Requests/>
                </Accordion.Body>
              </Accordion.Item>
            </div>
            <div>
              <Accordion.Item eventKey="2">
                <Accordion.Header>نحوه آشنایی</Accordion.Header>
                <Accordion.Body>
                    <Introduction/>
                </Accordion.Body>
              </Accordion.Item>
            </div>
           
          </div>
        </Accordion>
      </div>
    </div>
    </>
  );
}

export default Products;
